<template>
  <AdminBackground>
    <div class="image-wrapper">
      <img
        src="@/assets/header/VEKTOR.png"
        alt=" VEKTOR"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>
    <div class="tabs-wrapper">
      <select
        v-model="currentTabComponent"
        class="tabs-dropdown"
      >
        <option value="tab-dfic">
          Dengue Fever Information Centre (DFIC)
        </option>
        <option value="tab-denggi">
          Program Kawalan Denggi
        </option>
        <option value="tab-tikus">
          Program Kawalan Tikus
        </option>
      </select>
    </div>

    <component :is="components[currentTabComponent]" />
    <PrimaryModule />
    <KesihatanPersekitaran />
  </AdminBackground>
</template>

<script setup>
import KesihatanPersekitaran from '@/components/menu-items/section-menu/kesihatan-persekitaran-menu.vue'
import TabDenggi from "@/pages/kesihatan-persekitaran/vektor/denggi.vue"
import TabDfic from "@/pages/kesihatan-persekitaran/vektor/dfic.vue"
import TabTikus from "@/pages/kesihatan-persekitaran/vektor/tikus.vue"
import { ref } from 'vue'

const currentTabComponent = ref('tab-dfic')

// Map the string keys to actual components
const components = {
  'tab-dfic': TabDfic,
  'tab-denggi': TabDenggi,
  'tab-tikus': TabTikus,
}

//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  border-radius: 20px; /* Rounded corners */
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; /* Adjusted size */
  height: auto;
}

.line-under-image {
  width: 70%;
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
}

.tabs-wrapper {
  display: flex;
  justify-content: flex-start; 
  align-items: center;
  width: 78%; 
  margin-top: -10px;
}


.tabs-dropdown {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: white;
  color: black;
  font-size: 1rem;
  width: 100%; 
  margin-left: 0; 
  max-width: 400px;

  /* Add arrow styling */
  appearance: none; /* Remove default browser styles */
  -webkit-appearance: none; /* Safari-specific */
  -moz-appearance: none; /* Firefox-specific */
  background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 5"><path fill="black" d="M2 0L0 2h4z"/></svg>'); /* Custom arrow */
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 10px 10px;
}

.tabs-dropdown option {
  color: black; 
}
</style>
